import { flatten, isEmpty, isObjectLike, join, map, pickBy } from 'lodash';

export const generateUniqueChartKeys = (dataObj, appendKey = '') => {
  const traverse = (obj, prefix = '') => {
    return map(
      pickBy(obj, (value) => isObjectLike(value) && !isEmpty(value)),
      (values, key) => {
        if (Array.isArray(values)) {
          return map(values, (item) => `${prefix}${key}-${item.period}-${item.value}`);
        } else if (isObjectLike(values)) {
          // Recursively handle nested objects
          return traverse(values, `${prefix}${key}-`);
        }
      },
    );
  };

  const flattened = flatten(traverse(dataObj));
  const result = join(flattened, '_')
    .replace(/\s+/g, '')
    .replace(/[^a-zA-Z0-9]/g, '_');
  return appendKey ? `${appendKey}_${result}` : result;
};
